import moment from 'moment'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'
import { useGeneralContext } from './contexts/GeneralContext'
import { navDirections } from './utils/navDirections'

function RankList() {
    const { rankListSelected } = useGeneralContext()

    return (
        (!!rankListSelected && (
            <RankListContainer>
                <Heading>Rank List</Heading>

                <GeneralDetailsCard>
                    {!!!(rankListSelected?.mode === 'offline') ? (
                        <>
                            <SubjectName>
                                {rankListSelected?.subject}
                            </SubjectName>
                            <TitleOfExam>{rankListSelected?.title}</TitleOfExam>{' '}
                        </>
                    ) : (
                        <>
                            <TitleOfExamOffline>
                                {rankListSelected?.exam}
                            </TitleOfExamOffline>
                        </>
                    )}

                    {!!!(rankListSelected.mode === 'offline') ? (
                        <MarkAndDate>
                            <p>{`Total Mark : ${rankListSelected?.totalMark}`}</p>
                            <p>{rankListSelected?.date}</p>
                        </MarkAndDate>
                    ) : (
                        <MarkAndDate>
                            <p>{`Total Mark : ${rankListSelected?.totalMark}`}</p>
                            <p>
                                {moment(
                                    new Date(
                                        rankListSelected?.dateOfExam?.toDate()
                                    )
                                ).format('DD/MM/YYYY')}
                            </p>
                        </MarkAndDate>
                    )}
                </GeneralDetailsCard>

                <RankListTableWrapper>
                    <RankListTable>
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Name</th>
                                <th>Mark</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!rankListSelected?.rankList &&
                                rankListSelected?.rankList?.map((st, key) => (
                                    <tr key={key}>
                                        {!!!(
                                            rankListSelected?.mode === 'offline'
                                        ) ? (
                                            <td>
                                                {st?.st_mark > -77777
                                                    ? st?.st_rank
                                                    : '--'}
                                            </td>
                                        ) : (
                                            <td>
                                                {!!st.present ? st.rank : '--'}
                                            </td>
                                        )}

                                        <td>
                                            {!!!(
                                                rankListSelected?.mode ===
                                                'offline'
                                            )
                                                ? st?.st_name
                                                : st?.name}
                                        </td>

                                        {!!!(
                                            rankListSelected?.mode === 'offline'
                                        ) ? (
                                            <td>
                                                {st?.st_mark > -77777
                                                    ? st?.st_mark
                                                    : 'AB'}
                                            </td>
                                        ) : (
                                            <td>
                                                {!!st.present
                                                    ? st.mark
                                                    : 'ABSENT'}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                        </tbody>
                    </RankListTable>
                </RankListTableWrapper>
            </RankListContainer>
        )) || <Redirect to={navDirections.EXAM_RESULTS} />
    )
}

const RankListContainer = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const GeneralDetailsCard = styled.div`
    margin-top: 20px;
    padding: 30px 20px;
    max-width: 500px;
    background: #2e2e53;
    box-shadow: -5px 3px 14px rgba(0, 0, 0, 0.12),
        2px 8px 10px rgba(0, 0, 0, 0.14), 2px 5px 5px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    width: 100%;
    color: #fff;
`

const SubjectName = styled.p`
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
`
const TitleOfExam = styled.p`
    font-weight: 400;
    color: #fff;
    margin-bottom: 20px;
    margin-top: 10px;
    text-align: center;
`
const TitleOfExamOffline = styled.p`
    font-weight: 500;
    color: #fff;
    margin-bottom: 20px;
    margin-top: 10px;
    text-align: center;
`
const MarkAndDate = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    > p {
        font-weight: 600;
        color: #fff;

        &:nth-child(2) {
            color: #9f9fb0;
        }
    }
`
const RankListTableWrapper = styled.div`
    width: 100%;
    max-width: 500px;
    margin-top: 30px;
    margin-bottom: 100px;
`
const RankListTable = styled.table`
    color: #fff;
    width: 100%;
    border-collapse: collapse;

    > thead,
    > tbody {
        > tr {
            > th,
            > td {
                border: 1px solid #363862;
                padding: 10px;

                &:nth-child(1) {
                    text-align: center;
                    border-left: 0;
                }
                &:nth-child(2) {
                    text-align: left;
                }
                &:nth-child(3) {
                    text-align: center;
                    border-right: 0;
                }
            }

            > th {
                font-weight: 600;
            }
            > td {
                font-weight: 400;
            }

            &:first-child > th {
                border-top: 0;
            }
            &:last-child > td {
                border-bottom: 0;
            }
        }
    }
`

export default RankList
